import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: var(--margin-5);
	overflow: auto;
	gap: 1rem;
	overflow: auto;
	min-height: 45rem;
`;

export const LottieContainer = styled.div`
	background: url('/assets/Background.png');
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	padding: 0 6rem;
`;
